import { ICheckIfUserIsInSegmentParams, ICheckIfUserIsInSegmentResponse, SegmentIds } from "../../interfaces/api/segmentationService/checkIfUserIsInSegment"
import ApiUtils from "../ApiUtils"
import { ISegmentationService } from "./ISegmentationService"

const SegmentationServiceUrls = {
	checkIsUserInSegment: (segmentId: SegmentIds) => `/v1/user-segments/${segmentId}/user-exists`,
}

export default class SegmentationServiceApis implements ISegmentationService {
	getServiceUrl = (path: string) => {
		return "/segmentation-service" + path
	}

	checkIfUserIsInSegment = (params: ICheckIfUserIsInSegmentParams): Promise<ICheckIfUserIsInSegmentResponse> => {
		const { userIds, segmentId } = params

		const url = this.getServiceUrl(SegmentationServiceUrls.checkIsUserInSegment(segmentId))
		return ApiUtils.post(url, [...userIds])
	}
}
